const frontendURL = '/cat/executive/';
const backendURL = '/api/references/refexecutive/';
const name = 'Посадова особа організації (інспекції)';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
